'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SortOrderSelect = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortOrderSelect = function SortOrderSelect(refs) {
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.ComboBox', {
        cls: 'ns-combo',
        style: 'margin-bottom:' + _Style2.default.comboBottomMargin + 'px',
        width: _Style2.default.cmpWidth,
        labelWidth: _Style2.default.labelWidth,
        fieldLabel: i18n.sort_order,
        labelSeparator: null,
        labelStyle: 'color:#333',
        queryMode: 'local',
        valueField: 'id',
        editable: false,
        value: 0,
        store: Ext.create('Ext.data.Store', {
            fields: ['id', 'text'],
            data: [{ id: 0, text: i18n.none }, { id: -1, text: i18n.low_to_high }, { id: 1, text: i18n.high_to_low }]
        })
    });
};

exports.SortOrderSelect = SortOrderSelect;
exports.default = SortOrderSelect;
//# sourceMappingURL=SortOrder.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/SortOrder.js
 ** module id = 360
 ** module chunks = 0
 **/